module.exports = __webpack_public_path__ + "img/cliente04.934f7dfd.jpg";